import useNewCareerPositionContext from 'contexts/career-position.context';
import { parseBulletPoints } from 'pages/create-career-position/create-job-details/utils';

import React from 'react';

const PreviewJobDescription = () => {
  const { createJobPositionForm } = useNewCareerPositionContext();

  const details = [
    { value: parseBulletPoints(createJobPositionForm.responsibilities), label: 'Responsibilities' },
    { value: parseBulletPoints(createJobPositionForm.qualifications), label: 'Qualifications' }
  ];
  return (
    <div className='space-y-6'>
      <div className='border border-gray-1 rounded-md p-3.5 flex items-center mb-4'>
        <h2 className='text-sm   text-gray-5 w-40 shrink-0 '>Role summary</h2>
        <p className='text-gray-6 font-medium text-sm'>{createJobPositionForm.roleSummary}</p>
      </div>

      {details.map((detail) => (
        <div
          key={detail.label}
          className='border border-gray-1 rounded-md p-3.5 flex items-center mb-4'>
          <h2 className='text-sm   text-gray-5 w-40'>{detail.label}</h2>
          <ul className='text-sm text-gray-6 font-medium list-disc list-outside space-y-1.5'>
            {detail.value.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default PreviewJobDescription;
